import { HasPermissionFunction, Requirement } from "./types";
type HigherOrderRequirement = (requirements: Requirement) => Requirement;
type HigherOrderRequirements = (requirements: Requirement[]) => Requirement;
export const not: HigherOrderRequirement = requirement => p => !requirement(p);
export const any: HigherOrderRequirements = requirements => p =>
  requirements.some(r => r(p));
export const all: HigherOrderRequirements = requirements => p =>
  requirements.every(r => r(p));
export const none: HigherOrderRequirements = requirements => p =>
  !any(requirements)(p);
export const needs = (n: string) => (p: HasPermissionFunction) => p(n);
const permitAnything: Requirement = _p => true;
export const needsAny = (n: Array<string>) =>
  n.length > 0 ? any(n.map(x => needs(x))) : permitAnything;
